import React from "react";
import classNames from "classnames";
import Icon from "../elements/icon";
import PropTypes from "prop-types";
import PlainButton from "../elements/plain-button";

const FlexTableSortHeaderCell = props => (
  <PlainButton className={classNames("et--flex-table--sort-header-cell", props.className)} onClick={props.onClick}>
    {props.children}
    {props.isSorted && <Icon className={props.iconClassName} icon={props.sortOrder ? "arrow-down" : "arrow-up"} />}
  </PlainButton>
);

FlexTableSortHeaderCell.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  isSorted: PropTypes.bool,
  iconClassName: PropTypes.string,
  sortOrder: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.array, PropTypes.string]),
};
export default FlexTableSortHeaderCell;
